<div class="container">
  <div class="row">
    <div class="card col-md-8 offset-md-2">
      <div class="card-header">
        <h2>Brak dostępu</h2>
      </div>
      <div class="card-body">
        <p>
          Nie posiadasz odpowiednich uprawnień do strony.
        </p>
        <div class="text-center mt-5 mb-5">
          <a class="btn btn-success" href="/" role="button">Przejdź do strony głównej</a>
        </div>
      </div>
    </div>
  </div>
</div>
